import { PrimaryButton } from "@rpforms/shared";
import { SmallButton } from "@rpforms/shared/build/components/layout/Button";
import { batchDelete } from "@rpforms/shared/build/actions/actions_helper";
import { fetchDeviceTasks } from "@rpforms/shared/build/actions/tasks";
import { getFormEntry, getFormEntryForPdf } from "@rpforms/shared/build/actions/formEntries";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { FormEntryDetailsModal } from "./FormEntryDetailsModal";
import { DoorReportModal } from "./DoorReportModal";

const TaskListRow = styled.div`
    padding: 5px 0px;
    margin: 5px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const TaskInfo = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;


export const ListDeviceTasks = ({
    deviceTasks,
    deletable = true,
    calendarEvent,
}: {
    deviceTasks: any;
    deletable: boolean;
    calendarEvent?: any;
}) => {
    const [selectedDeviceTaskIds, setSelectedDeviceTaskIds] = useState([]);
    const [selectedFormEntry, setSelectedFormEntry] = useState(null);
    const [showFormEntryModal, setShowFormEntryModal] = useState(false);
    const [loadingFormEntry, setLoadingFormEntry] = useState(false);
    const [selectedDoorReportEntry, setSelectedDoorReportEntry] = useState(null);
    const [showDoorReportModal, setShowDoorReportModal] = useState(false);
    const [loadingDoorReport, setLoadingDoorReport] = useState(false);

    const dispatch = useDispatch();


    const showFormEntryDetails = async (deviceTask: any) => {
        if (deviceTask.form_entry_id) {
            setShowFormEntryModal(true);
            setLoadingFormEntry(true);
            setSelectedFormEntry(null);
            
            try {
                dispatch(getFormEntry(deviceTask.form_entry_id, (formEntry) => {
                    setSelectedFormEntry(formEntry);
                    setLoadingFormEntry(false);
                }));
            } catch (error) {
                console.error('Error fetching form entry details:', error);
                toast.error('Fehler beim Laden der Details');
                setShowFormEntryModal(false);
                setLoadingFormEntry(false);
            }
        }
    };

    const hideFormEntryModal = () => {
        setShowFormEntryModal(false);
        setSelectedFormEntry(null);
        setLoadingFormEntry(false);
    };

    const showDoorReport = async (deviceTask: any) => {
        if (deviceTask.form_entry_id) {
            setShowDoorReportModal(true);
            setLoadingDoorReport(true);
            setSelectedDoorReportEntry(null);

            try {
                dispatch(getFormEntryForPdf(deviceTask.form_entry_id, (formEntry) => {
                    setSelectedDoorReportEntry(formEntry);
                    setLoadingDoorReport(false);
                }));
            } catch (error) {
                console.error("Error fetching door report data:", error);
                toast.error("Fehler beim Laden des Tür-Reports");
                setLoadingDoorReport(false);
            }
        }
    };

    const hideDoorReport = () => {
        setShowDoorReportModal(false);
        setSelectedDoorReportEntry(null);
        setLoadingDoorReport(false);
    };

    const deleteDeviceTasks = () => {
        if (selectedDeviceTaskIds.length === deviceTasks.length) {
            toast.error("Ein Event kann nicht ohne Aufgaben existieren", { autoClose: 2000 });
            return;
        }
        return dispatch(
            batchDelete("device_tasks", selectedDeviceTaskIds, () => {
                dispatch(fetchDeviceTasks(calendarEvent.id));
            })
        );
    };

    const toggleDeviceTaskId = (dt) => {
        const tId = dt.target.value;
        const deviceTaskId = parseInt(tId, 10);
        if (!selectedDeviceTaskIds.includes(deviceTaskId)) {
            setSelectedDeviceTaskIds(selectedDeviceTaskIds.concat([deviceTaskId]));
        } else {
            setSelectedDeviceTaskIds(selectedDeviceTaskIds.filter((a) => a !== deviceTaskId));
        }
    };

    return (
        <>
            {deviceTasks.map((dt) => {
                const id = dt.id;
                return (
                    <TaskListRow key={id}>
                        <TaskInfo>
                            <Form.Check type="checkbox" id={"deviceTask-" + id}>
                                {deletable && (
                                    <Form.Check.Input
                                        checked={selectedDeviceTaskIds.includes(id)}
                                        type="checkbox"
                                        value={id}
                                        onChange={toggleDeviceTaskId}
                                    />
                                )}
                            {dt.form_entry_id && (
                                <SmallButton
                                    onClick={() => showFormEntryDetails(dt)}
                                    title="Formular-Eintrag Details anzeigen"
                                    className="btn-info"
                                    style={{ marginLeft: "10px" }}
                                >
                                    <i className="fa fa-info-circle"></i> Info
                                </SmallButton>
                            )}
                            {dt.form_entry_id && dt.form_name === "000_Angebot" && (
                                <SmallButton
                                    onClick={() => showDoorReport(dt)}
                                    title="Tür-Report anzeigen"
                                    className="btn-secondary"
                                    style={{ marginLeft: "10px" }}
                                >
                                    <i className="fa fa-file-text-o"></i> Tür Report erzeugen
                                </SmallButton>
                            )}
                                <Form.Check.Label className={"mt-0"}>
                                    <span>
                                        {dt.form_name}{" "}
                                        {dt.entity_name && (
                                            <span>
                                                <i className={"fa fa-home"}></i> {dt.entity_name}
                                            </span>
                                        )}{" "}
                                    </span>
                                </Form.Check.Label>
                            </Form.Check>

                            {dt.is_overwrite && (
                                <span style={{ fontStyle: "italic", marginLeft: "5px" }}>
                                    (Überschreibt alten Eintrag)
                                </span>
                            )}
                        </TaskInfo>
                    </TaskListRow>
                );
            })}
            <div className="row ml-1">
                <PrimaryButton onClick={deleteDeviceTasks}>
                    {selectedDeviceTaskIds.length > 1 ? "Aufgaben löschen" : "Aufgabe löschen"}
                </PrimaryButton>
            </div>
            
            <FormEntryDetailsModal 
                formEntry={selectedFormEntry}
                show={showFormEntryModal}
                onHide={hideFormEntryModal}
                loading={loadingFormEntry}
            />
            <DoorReportModal
                formEntry={selectedDoorReportEntry}
                show={showDoorReportModal}
                onHide={hideDoorReport}
                loading={loadingDoorReport}
                autoPrint={true}
            />
        </>
    );
};
